import stripTags from '@components/utils/stripTags';
import { emailRegex } from '@components/utils/regex';

const validateContactFormFields = (store, contact, t, values) => {
  Object.keys(values).forEach(name => {
    const value = values[name];
    const field = contact.fields.find(f => f.name === name);

    if (!field) {
      return;
    }

    if (field.required && (Array.isArray(value) ? !value.length : !value)) {
      if (field.error) {
        store.setError(name, field.error);
      } else {
        store.setError(
          name,
          t('fieldrequired', {
            field: stripTags(field.label),
          }),
        );
      }
    } else if (field.type === 'email' && !emailRegex.test(value)) {
      store.setError(
        name,
        t('fieldinvalid', { field: stripTags(field.label) }),
      );
    }
  });
};

export default validateContactFormFields;
